<div class="chart-container" style="position: relative; width:100%">
    <canvas id="myChart"></canvas>
</div>